import React, { useState } from 'react';
import './Dashboard/Dashboard.css';
import TopNav from './Dashboard/components/TopNav';
import Sidebar from './Dashboard/components/Sidebar';
import DayView from './Dashboard/components/DayView';
import MonthView from './Dashboard/components/MonthView';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

const DashboardPage = () => {
    const { user, loading } = useAuth();
    const [view, setView] = useState('day');

    if (loading) return null;
    if (!user) return <Navigate to="/login" replace />;

    return (
        <div className="dashboard-container">
            <div className="dashboard-layout">
                {/* Top Nav */}
                <TopNav setView={setView} currentView={view} />
                
                {/* Main Content Area */}
                <div className="dashboard-main">
                    {/* Left Sidebar */}
                    <Sidebar />
                    
                    {/* Right View Area */}
                    <div className="dashboard-content">
                        {view === 'day' ? <DayView /> : <MonthView />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardPage;
